import React from "react";
import {Link} from "react-router-dom";
import Image from 'antd/lib/image';
import {useSelector} from "react-redux";
import {formatCompanyLogoUrl} from "../Api/companyApi";


export const Brand = ({ route, maxHeight=80 }) => {
    const companyId = useSelector(state => state.user.data?.company_details?.cid);
    let brandImageUrl = formatCompanyLogoUrl(companyId);
    const containerContent = (
        <div className="brand-container" style={{ padding: '10px 5px', textAlign: 'center' }}>
                <Image
                  src={brandImageUrl}
                  alt="Brand"
                  preview={false} // Disable click-to-preview functionality
                  style={{ maxWidth: '100%', maxHeight: maxHeight }} // Adjust size as needed
                />
        </div>
    )
    return (
        route ? <Link to={route}>{containerContent}</Link> : containerContent
    );
};
